import React, { useState } from 'react';
import { ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';

interface Props {
  // Paso "Finalizar" del modal único de detalle — mismo patrón que
  // CancelAdvisoryLeadForm (no es un modal propio, evita modal-sobre-modal).
  onCancel: () => void;
  onConfirm: (notes?: string) => void;
}

// A diferencia de CancelAdvisoryLeadForm, las notas son opcionales — no hay
// nada que validar antes de poder confirmar.
const FinishAdvisoryLeadForm: React.FC<Props> = ({ onCancel, onConfirm }) => {
  const [notes, setNotes] = useState('');

  return (
    <>
      <ModalBody>
        <FormGroup>
          <Label for="finish-advisory-notes">Notas (opcional)</Label>
          <Input
            type="textarea"
            id="finish-advisory-notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Comentarios sobre cómo se dio la asesoría"
            rows={3}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onCancel}>
          Volver
        </Button>
        <Button
          color="success"
          className="px-4"
          onClick={() => onConfirm(notes.trim() || undefined)}
        >
          Finalizar asesoría
        </Button>
      </ModalFooter>
    </>
  );
};

export default FinishAdvisoryLeadForm;
